import React from 'react'

const PricingPlanCard = ({
    plan,
    isSelected = false,
    statusLabel = null,
    onSelect,
    onButtonClick,
    isLoading = false,
    isDisabled = false,
    loadingText = 'Redirecting to Stripe...',
    className = '',
}) => {
    const handleCardClick = () => {
        if (onSelect) {
            onSelect(plan)
        }
    }

    const handleButtonClick = (event) => {
        event.stopPropagation()
        if (onButtonClick) {
            onButtonClick(plan)
            return
        }
        if (onSelect) {
            onSelect(plan)
        }
    }

    return (
        <div
            className={`relative bg-white rounded-xl shadow-md border-2 transition-all overflow-visible ${
                isSelected ? 'border-green-500' : 'border-gray-200 hover:border-gray-300'
            } ${onSelect ? 'cursor-pointer' : ''} ${className}`}
            onClick={onSelect ? handleCardClick : undefined}
        >
            <div
                className="relative px-6 py-4 text-center text-white rounded-t-xl overflow-hidden"
                style={{ backgroundColor: '#0A2D75' }}
            >
                {plan.popular && (
                    <div
                        className="absolute top-2 -right-9 text-white text-[8px] font-bold px-8 py-1 transform rotate-45 z-20 whitespace-nowrap pointer-events-none"
                        style={{ backgroundColor: '#042663' }}
                    >
                        POPULAR
                    </div>
                )}
                <h4 className="text-2xl font-semibold tracking-wide uppercase text-white">{plan.name}</h4>
                <p className="text-xs mt-1 text-gray-200">
                    Billed monthly at {plan.monthlyPriceLabel || '—'}
                </p>
                {statusLabel && (
                    <p className="text-[11px] mt-2 text-custom-600 font-semibold">{statusLabel}</p>
                )}
            </div>

            <div className="p-6">
                <div className="mb-4 text-center">
                    <div className="flex items-start justify-center gap-1">
                        <span className="text-2xl font-semibold text-gray-900 leading-none mt-1">$</span>
                        <span className="text-5xl font-semibold text-gray-900 leading-none">
                            {plan.monthlyPrice || 0}
                        </span>
                    </div>
                    <div className="text-gray-700 text-xl mt-1">Monthly</div>
                </div>

                <p className="text-base text-gray-700 mb-6 text-center">
                    {plan.userLicenseLabel}
                </p>

                <div className="space-y-0 mb-8">
                    {(plan.features || []).map((feature, index) => (
                        <div key={index} className="py-2 text-center border-t border-gray-100">
                            <span className="text-sm text-gray-700">{feature}</span>
                        </div>
                    ))}
                </div>

                <button
                    type="button"
                    className="w-full py-3 px-4 rounded-lg font-medium transition-all text-white hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed"
                    style={{ backgroundColor: '#042663' }}
                    disabled={isDisabled || isLoading}
                    onClick={handleButtonClick}
                >
                    {isLoading ? loadingText : (plan.buttonText || 'Choose Plan')}
                </button>
            </div>
        </div>
    )
}

export default PricingPlanCard
